<template>
  <div class="player" :class="isRotateFullScreen ? 'isFullPlayer' : ''">
    <video class="video-player" :id="`player${playerVideo.id}`" preload="auto" :poster="poster" playsinline
           webkit-playsinline>
    </video>
    <div class="vertical-progress" :class="isRotateFullScreen ? 'isFull' : ''">
      <van-slider v-model="slider" vertical button-size="14" @change="handleChange"/>
    </div>
    <div
      class="vjs-knowledge-points vjs-menu-button vjs-menu-button-popup vjs-control vjs-button"
      :class="isRotateFullScreen ? 'isFull' : ''"
      @click="showKnowledgePoints"
    >知识点
    </div>
    <div class="knowledge-points-list" v-if="isShowKnowledgePoints">
      <div class="header">
        <div class="title">课程知识点</div>
        <div v-if="playerVideo.knowledgeList && playerVideo.knowledgeList.length" class="header-right">
          (<i>{{ isCurDotIndex }}</i>/{{ playerVideo && playerVideo.knowledgeList.length  }}个知识点)
        </div>
      </div>
      <div class="cont">
        <div class="dot-list-fullscreen"
             @touchstart.stop="handleTouchStart"
             @touchend.stop="handleTouchEnd"
             @scroll="handleScroll"
             @touchmove.stop
        >
          <div
            v-for="(item, index) in playerVideo.knowledgeList"
            :key="index"
            class="dot-item-fullscreen"
            v-track="{ functionName: `${item.knowledge}` }"
            :class="item.isCurrent ? 'cur':''"
            @click.stop="changeDotTime(item)"
          >
            <div class="dot-item-cont">
              <div class="dot-icon">
                <img src="../../../assets/images/course/dot-icon.png" alt="" v-if="!item.isCurrent">
                <img src="../../../assets/images/course/dot-icon-active.png" alt="" v-else>
              </div>
              <div class="dot-title">
                <span class="name">{{ item && item.knowledge }}</span>
              </div>
            </div>
            <div class="dot-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TCPlayer from 'tcplayer.js'
// import 'tcplayer.js/dist/tcplayer.min.css'
// import TcPlayerBarragePlugin from 'tcplayer-barrage-plugin'
import {handleTraceVideo, handleTraceVideoAsync} from '@/utils/trace.js'
// import { traceVideoDuration } from '@/api/trace.js'
import {stopScroll, canScroll} from '@/utils/util'
// import { getBarrage } from '@/api/api'
import {iconForward, iconBack} from '@/views/course/components/svg.js'

import Vue from 'vue'
import {ACCESS_TOKEN} from '../../../store/mutation-types'
export default {
  name: 'VideoPlayer',
  props: {
    // 视频源
    playerVideo: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      // 是否已经rotate全屏
      isRotateFullScreen: false,
      playDurationArr: [],
      playDuration: 0,
      playDurationTrace: 0,
      curVideoPlayer: {},
      player: {},
      poster: '',
      slider: 0,
      currentTime: 0,
      acPlayerToolInit: {},
      hasIdBool: false,
      isShowKnowledgePoints: false,
      isCurDotIndex: 0, // 当前播放的知识点索引
      allowAutoScroll: true,
      touchTimer: null
    }
  },
  computed: {
    isXFive() {
      let ua = navigator.userAgent.toLocaleLowerCase()
      return ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    playerVideo(newVal, oldVal) {
      this.curVideoPlayer = newVal
      this.handleInitPlayer()
    },
    currentTime() {
      this.updateDotListOrder()
    }
  },
  mounted() {
    this.curVideoPlayer = this.playerVideo
    this.handleInitPlayer()
    window.addEventListener('unload', this.unloadHandler)
  },
  beforeDestroy() {
    this.handleVideoTrace(this.curVideoPlayer)
    if (this.acPlayerToolInit.isPlayed) this.acPlayerToolInit.dispose()
    else this.acPlayerToolInit.player.dispose()
    localStorage.removeItem('playbackRate')
    localStorage.removeItem('curPlayVideoId')
    canScroll()
  },
  destroyed() {
    window.removeEventListener('unload', this.unloadHandler)
  },
  methods: {
    changeDotTime(item) {
      localStorage.setItem('functionUrl', `courseId=${this.playerVideo.baseId}&sectionId=${this.playerVideo.sectionId}&knowledgeId=${item.id}`)
      this.player.currentTime(item.knowledgeDuration)
    },
    // 手指按下时认为用户开始滚动知识点列表
    handleTouchStart() {
      this.allowAutoScroll = false
    },

    handleScroll(e) {
      this.allowAutoScroll = false
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
      }
      this.touchTimer = setTimeout(() => {
        this.allowAutoScroll = true
      }, 2000)
    },

    // 手指抬起后一小段时间内仍不允许置顶，防止滑动未结束
    handleTouchEnd() {
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
      }
      this.touchTimer = setTimeout(() => {
        this.allowAutoScroll = true
      }, 2000)
    },

    parseTimeToSeconds(timeStr) {
      const parts = timeStr.split(':').map(Number)
      let hours = 0
      let minutes = 0
      let seconds = 0

      // 根据分割结果的长度判断格式
      if (parts.length === 3) {
        // HH:MM:SS 格式
        [hours, minutes, seconds] = parts
      } else if (parts.length === 2) {
        // MM:SS 格式
        [minutes, seconds] = parts
      } else {
        throw new Error(`Invalid time format: ${timeStr}`)
      }

      return hours * 3600 + minutes * 60 + seconds
    },

    updateDotListOrder() {
      if (!this.playerVideo || !this.playerVideo.knowledgeList) return
      this.isCurDotIndex = 0
      this.playerVideo.knowledgeList.forEach((item, index) => {
        const start = this.parseTimeToSeconds(item.startTime)
        const end = this.parseTimeToSeconds(item.endTime)
        if (this.currentTime >= start && this.currentTime <= end) {
          this.isCurDotIndex = index + 1
          this.$set(item, 'isCurrent', true)
        } else {
          this.$set(item, 'isCurrent', false)
        }
      })

      this.$nextTick(() => {
        const parentContainer2 = document.querySelector('.dot-list-fullscreen') // 父容器
        const curDot2 = document.querySelector('.dot-item-fullscreen.cur')
        if (parentContainer2 && curDot2 && this.allowAutoScroll) {
          parentContainer2.scrollTop = curDot2.offsetTop
        }
      })
    },

    showKnowledgePoints() {
      this.isShowKnowledgePoints = !this.isShowKnowledgePoints
    },

    // 页面关闭，关闭包括了刷新，自动调用埋点数据
    unloadHandler(e) {
      this.handleVideoTraceSync(this.curVideoPlayer)
    },

    // // 初始化弹幕
    // async handleGetBarrage () {
    //   let danmuDom = document.getElementById('vjs-barrage-screen')
    //   let danmuDom2 = document.getElementsByClassName('vjs-barrage-switcher')[0]
    //   if (danmuDom) {
    //     danmuDom.remove()
    //     danmuDom2.remove()
    //   }
    //   let barrageData = await getBarrage({
    //     courseId: this.$route.query.courseId,
    //     courseSectionId: this.curVideoPlayer.baseId ? this.curVideoPlayer.baseId : this.curVideoPlayer.id
    //   })
    //   let barrageDataL = barrageData.data.map(res => {
    //     let items = {
    //       mode: '1',
    //       stime: res.barrageTime * 1000,
    //       text: res.barrageText,
    //       size: 16,
    //       color: '#FFFFFF'
    //     }
    //     return items
    //   })
    //   this.barragePlugin = new TcPlayerBarragePlugin(this.player, {})
    //   this.barragePlugin.init()
    //   this.barragePlugin.load(barrageDataL)
    //   this.barragePlugin.start()
    // },

    handleChange(value) {
      // 横屏进度条控制
      let setCurTime = this.curVideoDuration / 100 * value
      this.player.currentTime(setCurTime)
    },

    backward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const targetTime = Math.max(0, currentTime - 15)
        this.player.currentTime(targetTime)
      }
    },
    forward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const duration = this.player.duration()
        if (currentTime + 15 >= duration) return
        const targetTime = Math.min(duration, currentTime + 15)
        this.player.currentTime(targetTime)
      }
    },

    // 初始化视频
    handleInitPlayer() {
      let initPlayCon = this.curVideoPlayer
      let idOptions = {
        app_Play_Id: new Date().getTime() + '' + Math.round(Math.random() * 999) + 1, // 播放ID（类型：String，长度16位，唯一）
        app_Id: 'IEP', // 应用ID（类型：String，也可叫做渠道ID如：wechat）
        user_Id: Math.round(Math.random() * 999) + 1, // this.userInfo.id, // 用户ID（类型：Number，调用方系统里的用户ID）
        video_Id: initPlayCon.fileId// 视频ID（类型：Number，调用方系统里的视频ID）
      }
      let userInfo = this.userInfo
      let videoTitle = this.curVideoPlayer.title
      let videoSize = 0
      let tencentid = initPlayCon.fileId
      let heartbeatsFreq = 1
      let acPlayerToolInit = window.acPlayerToolInit(`player${this.curVideoPlayer.id}`, {
        fileID: initPlayCon.fileId,
        appID: initPlayCon.appId, // 腾讯的appID
        psign: initPlayCon.psign,
        licenseUrl: 'https://1307224350.trtcube-license.cn/license/v2/1307224350_1/v_cube.license',
        fakeFullscreen: true
      }, idOptions, userInfo, videoTitle, videoSize, tencentid, heartbeatsFreq)
      this.acPlayerToolInit = acPlayerToolInit
      let player = acPlayerToolInit.player

      // let player = TCPlayer(`player${this.curVideoPlayer.id}`, { // player-container-id 为播放器容器 ID，必须与 html 中一致
      //   fileID: initPlayCon.fileId, // 请传入需要播放的视频 fileID（必须）
      //   appID: initPlayCon.appId, // 请传入点播账号的 appID（必须）
      //   // 私有加密播放需填写 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
      //   psign: initPlayCon.psign,
      //   fakeFullscreen: true
      //   // licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1255472182_1/v_cube.license',
      //   // licenseUrl: 'https://license-url',
      // })
      this.poster = this.curVideoPlayer.poster ? this.curVideoPlayer.poster : this.curVideoPlayer.coverUrl
      player.poster(this.poster)
      // this.handleGetBarrage()
      // 默认当前播放的player内容coverUrl
      this.player = player
      // 获取视频dom
      let videoDom = document.getElementById(`player${this.curVideoPlayer.id}`)
      // // 获取视频下面转圈圈的dom
      // let tcpLoadingSpinnerDom = videoDom.getElementsByClassName('tcp-loading-spinner')[0]
      // tcpLoadingSpinnerDom.style.display = 'none'
      // 初始化播放按钮的dom
      let vjsBigPlayButtonDom = videoDom.getElementsByClassName('vjs-big-play-button')[0]
      if (vjsBigPlayButtonDom) vjsBigPlayButtonDom.style.display = 'none'

      console.log(this.player, 'asdf')

      player.on('loadstart', () => {
        // 记录一个空格，在空格李米娜假如快进快退
        let vjsPBTDIV = document.getElementsByClassName('vjs-custom-control-spacer')[0]
        if (vjsPBTDIV.className.indexOf('vjs-custom-control-fast') < 0) {
          vjsPBTDIV.classList.add('vjs-custom-control-fast')
          // 将 SVG 字符串转换为 DOM 节点
          let iconBackElement = document.createElement('div')
          iconBackElement.innerHTML = iconBack
          let iconForwardElement = document.createElement('div')
          iconForwardElement.innerHTML = iconForward
          // 获取第一个子元素，即 SVG 元素
          iconForwardElement = iconForwardElement.firstChild
          iconBackElement = iconBackElement.firstChild
          iconBackElement.addEventListener('click', (e) => {
            this.backward15Seconds()
            e.stopPropagation()
          })
          iconForwardElement.addEventListener('click', (e) => {
            this.forward15Seconds()
            e.stopPropagation()
          })
          // 插入到第一个位置
          vjsPBTDIV.insertBefore(iconForwardElement, vjsPBTDIV.firstChild)
          vjsPBTDIV.insertBefore(iconBackElement, vjsPBTDIV.firstChild)
        }
        // 设置当前视频从第几秒开始,作用于播放记录
        const videoHistory = window.localStorage.getItem('videoHistory')
        let lastPlayTime = videoHistory ? JSON.parse(videoHistory)[this.curVideoPlayer.id] : 0
        player.currentTime(lastPlayTime)
        // 设置当前视频播放速度
        if (localStorage.getItem('playbackRate')) {
          player.playbackRate(localStorage.getItem('playbackRate'))
        } else {
          player.playbackRate(1)
        }
      })

      player.on('play', () => {
        let videoSectionId = sessionStorage.getItem('videoSectionId')
        if (sessionStorage.getItem('curPlaySessionVideo')) {
          let curPlaySessionVideo = JSON.parse(sessionStorage.getItem('curPlaySessionVideo'))
          if (curPlaySessionVideo.id === videoSectionId || curPlaySessionVideo.sectionId === videoSectionId) {
            curPlaySessionVideo.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
            this.playDurationTrace = 0
            this.handleStaticDuration()
            handleTraceVideo(curPlaySessionVideo)
          }
        }
        sessionStorage.setItem('curPlaySessionVideo', JSON.stringify(this.curVideoPlayer))
        if ((this.curVideoPlayer.id !== videoSectionId && this.curVideoPlayer.sectionId !== videoSectionId) || !videoSectionId) {
          this.curVideoPlayer.duration = 1 // 页面停留时长，向上取整
          handleTraceVideo(this.curVideoPlayer)
        }
        // 默认开始播放的时候提交状态为2
        this.$emit('handlePlay', this.curVideoPlayer)
      })

      // 播放器暂停时触发
      player.on('pause', () => {
        this.handleStashVideoTime(this.curVideoPlayer)
      })

      // 监听视频倍速切换时记录下倍速
      player.on('ratechange', (e) => {
        if (!localStorage.getItem('curPlayVideoId') || localStorage.getItem('curPlayVideoId') === this.curVideoPlayer.id) {
          let playbackRate = player.playbackRate()
          localStorage.setItem('playbackRate', playbackRate)
          localStorage.setItem('curPlayVideoId', this.curVideoPlayer.id)
        } else {
          localStorage.setItem('curPlayVideoId', this.curVideoPlayer.id)
        }
      })

      // 当前时间变化调用的一次性函数
      player.on('timeupdate', (e) => {
        // 获取当前时间
        let curTime = player.currentTime()
        // 获取当前时间，记录当前播放时间
        this.currentTime = curTime
        // 记录当前视频总长度
        this.curVideoDuration = player.duration()
        // 是否显示横屏进度条
        // 判读是否是手机
        const isMobile = /iPhone|Android/i.test(navigator.userAgent)
        // const isMobile = /Mobile/i.test(navigator.userAgent) // ipad Mini 监听不到
        const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        let videoBtmCon = document.querySelector('.video-js').className + ''
        if ((isMobile && deviceWidth < 768) && player.isFullscreen() && (videoBtmCon.indexOf('vjs-paused') > -1 || videoBtmCon.indexOf('vjs-user-active') > -1)) {
          verticalProDom.style.display = 'block'
        } else {
          verticalProDom.style.display = 'none'
        }
        // 横屏进度条控制
        this.slider = this.currentTime / this.curVideoDuration * 100
        // 判断最后4秒提示跳到下一个视频，如果还有下一个视频
        // if (this.curVideoDuration - curTime <= 10) {
        //   let curIndex = 0
        //   this.videoList.map((item, index) => {
        //     if (item.id === this.curVideoPlayer.id) {
        //       curIndex = index
        //     }
        //   })
        //   if (curIndex + 1 < this.videoList.length) {
        //     let curVideo = this.videoList[curIndex + 1]
        //     this.nextVideoTitle = curVideo.title
        //     this.boolNextTip = true
        //   }
        // } else {
        //   this.boolNextTip = false
        // }
        if (curTime >= player.duration()) {
          this.handleVideoTrace(this.curVideoPlayer)
        }
        this.playDurationArr.push(curTime)
        if (this.playDurationArr.length > 1) {
          this.handleStaticDuration()
          this.$emit('timeupdate', {
            currentTime: curTime,
            playDuration: this.playDuration,
            currentVideo: this.curVideoPlayer
          })
        }
        if (this.playDurationTrace > 5) {
          this.curVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
          this.playDurationTrace = 0
          this.handleStaticDuration()
          handleTraceVideo(this.curVideoPlayer)
        }
      })

      // 切换视频的全屏
      player.on('fullscreenchange', (e) => {
        // 是否显示横屏进度条
        let verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        let playerDom = document.getElementById(`player${this.playerVideo.id}`)
        const vjsPlaybackRate = document.getElementsByClassName('vjs-playback-rate')[0]
        const vjsKnowledgePoints = document.getElementsByClassName('vjs-knowledge-points')[0]
        // 判读是否是手机
        const isMobile = /iPhone|Android/i.test(navigator.userAgent)
        // const isMobile = /Mobile/i.test(navigator.userAgent) // ipad Mini 监听不到
        const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        console.log(isMobile, deviceWidth < 768, navigator.userAgent, deviceWidth)
        if (isMobile && deviceWidth < 768) {
          this.isRotateFullScreen = player.isFullscreen()
          let progressControlDom = document.getElementsByClassName('vjs-progress-control')[0]
          if (player.isFullscreen()) {
            playerDom.classList.add('player-isfullscreen')
            if (this.playerVideo.knowledgeList && this.playerVideo.knowledgeList.length) {
              vjsPlaybackRate.before(vjsKnowledgePoints)
              vjsKnowledgePoints.style.display = 'flex'
            }
            progressControlDom.style.display = 'none'
            verticalProDom.style.display = 'block'
            stopScroll()
          } else {
            this.isShowKnowledgePoints = false
            playerDom.classList.remove('player-isfullscreen')
            vjsKnowledgePoints.style.display = 'none'
            progressControlDom.style.display = 'flex'
            verticalProDom.style.display = 'none'
            canScroll()
          }
        } else {
          if (player.isFullscreen()) {
            playerDom.classList.add('player-isfullscreen2')
            verticalProDom.style.display = 'none'
            stopScroll()
          } else {
            playerDom.classList.remove('player-isfullscreen2')
            canScroll()
          }
        }
      })
    },

    // 缓存历史记录
    handleStashVideoTime(videoData) {
      if (!videoData) return
      if (window && window.localStorage && this.currentTime > 0) {
        let videoHistory = window.localStorage.getItem('videoHistory')
        if (this.curVideoDuration <= this.currentTime) {
          this.currentTime = 0
        }
        if (videoHistory) {
          videoHistory = Object.assign(JSON.parse(videoHistory), {[videoData.id]: this.currentTime})
        } else {
          videoHistory = {[videoData.id]: this.currentTime}
        }
        window.localStorage.setItem('videoHistory', JSON.stringify(videoHistory))
      }
    },

    // 视频播放时长统计
    handleStaticDuration() {
      if (this.playDurationArr.length > 1) {
        this.playDurationArr[0] = (this.playDurationArr[1] - this.playDurationArr[0] > 1 || this.playDurationArr[0] > this.playDurationArr[1]) ? this.playDurationArr[1] : this.playDurationArr[0]
        this.playDuration = this.playDuration + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationTrace = this.playDurationTrace + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationArr = [this.playDurationArr[this.playDurationArr.length - 1]]
      }
    },

    // 埋点方法
    handleVideoTrace(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      // 监听销毁时的动作
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.playDuration >= 1) {
        this.endTime = new Date() // 埋点观看结束时间
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        handleTraceVideo(this.precurVideoPlayer)
        // 上报当前视频播放时长
        // const params = {
        //   videoId: this.precurVideoPlayer.sectionId,
        //   iepUserId: this.userInfo.id,
        //   playDuration: Math.round(this.playDuration),
        //   // courseId: this.$route.query.courseId
        // }
        // if (sessionStorage.getItem('traningCampId')) {
        //   params['campId'] = sessionStorage.getItem('traningCampId')
        // }
        // traceVideoDuration(params).then(() => { })
        this.playDuration = 0
      }
      this.currentTime = 0
      sessionStorage.removeItem('curPlaySessionVideo')
      sessionStorage.removeItem('videoSectionId')
      sessionStorage.removeItem('videoTraceId')
    },

    // 页面关闭或者刷新的时候特意用fetch同步请求
    handleVideoTraceSync(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      const token = Vue.ls.get(ACCESS_TOKEN)
      const baseURL = process.env.baseURL
      // 监听销毁时的动作
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.playDuration > 0) {
        this.endTime = new Date() // 埋点观看结束时间
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        // handleTraceVideo(this.precurVideoPlayer)
        this.precurVideoPlayer = Object.assign(this.precurVideoPlayer, {
          token,
          baseURL
        })
        handleTraceVideoAsync(this.precurVideoPlayer)
        console.log(this.precurVideoPlayer, '112')
        // 上报当前视频播放时长
        // const params = {
        //   videoId: this.precurVideoPlayer.sectionId,
        //   iepUserId: this.userInfo.id,
        //   playDuration: Math.round(this.playDuration)
        // }
        // if (sessionStorage.getItem('traningCampId')) {
        //   params['campId'] = sessionStorage.getItem('traningCampId')
        // }
        // fetch(`${baseURL}/api/course/completed/records/addPlayDuration/${params.videoId}`, {
        //   method: 'POST',
        //   body: JSON.stringify(params),
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${token}`,
        //     'userId': this.userInfo.id
        //   },
        //   keepalive: true
        // })
        // this.playDuration = 0
      }
      this.currentTime = 0
      sessionStorage.removeItem('curPlaySessionVideo')
      sessionStorage.removeItem('videoSectionId')
      sessionStorage.removeItem('videoTraceId')
    },
  }
}

</script>

<style lang="less" scoped>
.video-js {
  /deep/ .vjs-control-bar {
    .vjs-play-control, .vjs-volume-panel, .vjs-mute-control, .vjs-volume-control, .vjs-current-time, .vjs-duration, .vjs-playback-rate, .vjs-fullscreen-control {
      width: 3em;
    }
  }

  /deep/ .vjs-pdt-time {
    display: none;
  }

  /deep/ .vjs-custom-control-spacer {
    flex: 1;
  }

  /deep/ .vjs-control-bar {
    display: flex;
    align-items: center;
  }

  /deep/ .vjs-volume-panel.vjs-volume-panel-vertical {
    width: 3em;
  }

  /deep/ .vjs-barrage-switcher {
    display: none;
  }

  /deep/ .vjs-mute-control {
    padding: 0;
  }

  /deep/ .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
    left: -3em;
    margin-left: 0;
  }

  /deep/ .tcp-video-quality-switcher {
    display: none;
  }

  /deep/ .vjs-custom-control-fast {
    display: flex !important;
    align-items: center;
    width: 80px !important;
  }
  /deep/ .icon_fast {
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    margin-right: 10px;
  }
}
</style>
<style lang="less" scoped>
.player {
  width: 100%;

  .knowledge-points-list {
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, .8);
    border-radius: 20px;
    padding: 0 15px 10px;
    width: 205px;
    height: calc(100vw - 60px);
    left: 98vw;
    top: calc(100vh - 240px);
    box-sizing: border-box;
    -webkit-transform-origin: top left !important;
    -ms-transform-origin: top left !important;
    transform-origin: top left !important;
    -webkit-transform: rotate(90deg) !important;
    -ms-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #fff;
      }

      .header-right {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #fff;

        i {
          font-style: normal;
          color: #EB1700;
        }
      }
    }

    .cont {
      flex: 1;
      height: 0;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .dot-list-fullscreen {
        flex: 1;
        height: 0;
        overflow-y: auto;
        padding-right: 16px;
        margin-right: -16px;
        position: relative;

        .dot-item-fullscreen {
          cursor: pointer;
          position: relative;
          margin-bottom: 10px;

          .dot-item-cont {
            display: flex;
            align-items: flex-start;

            .dot-icon {
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 6px;

              img {
                width: 6px;
              }
            }

            .dot-title {
              display: flex;
              flex: 1;
              align-items: flex-start;

              .time {
                font-family: PingFang HK, PingFang HK;
                font-weight: 400;
                font-size: 12px;
                color: #FFF;
              }

              .name {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #FFF;
                flex: 1;
              }
            }
          }

          &:last-child {
            height: auto;
            margin-bottom: 0;

            .dot-line {
              display: none;
            }
          }

          .dot-line {
            position: absolute;
            top: 14px;
            left: 2px;
            width: 2px;
            height: 100%;
            border-radius: 10px;
            background: url("~@/assets/images/course/dot-line.png") no-repeat center center / 100% 100%;
          }

          &.cur {
            .dot-item-cont {
              .dot-title {
                .time {
                  color: #EB1700;
                }

                .name {
                  color: #EB1700;
                }
              }
            }
          }
        }
      }

      .course-summary {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #5F5F5F;

        span {
          font-weight: 500;
          color: #2B2B2B;
        }
      }
    }
  }

  .video-player {
    width: 100%;
    left: 0;
    height: 200px;

    &.player-isfullscreen2 {
      z-index: 999 !important;
    }

    &.player-isfullscreen {
      position: fixed !important;
      z-index: 9999 !important;
      top: 0 !important;
      left: 100% !important;
      bottom: 0 !important;
      right: 0 !important;
      height: 100vw !important;
      width: 100vh !important;
      -webkit-transform-origin: top left !important;
      -ms-transform-origin: top left !important;
      transform-origin: top left !important;
      -webkit-transform: rotate(90deg) !important;
      -ms-transform: rotate(90deg) !important;
      transform: rotate(90deg) !important;
    }
  }

  .vjs-knowledge-points {
    display: none;
    color: #fff;
    font-weight: bold;
    align-items: center;

    &.isFull {
      display: flex;
    }
  }

  .vertical-progress {
    position: fixed;
    left: 42px;
    height: calc(100vh - 20px);
    margin: 10px 0;
    z-index: 9999;
    top: 0;
    display: none;

    &.isFull {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/VideoPlayerAnswer.vue